import styled from "styled-components";
import { Button as AntButton } from 'antd';

export const RootContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #F4F4F4;
  min-height: calc(100vh - 100px);
`;

export const HistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  width: calc(100% - 32px);
  margin: 0 auto;
`;

export const HistoryBox = styled.div`
  border-radius: 8px;
  background: #FFF;
  padding: 16px;
  gap: 10px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: baseline;
  align-items: flex-start;
  row-gap: 6px;

  flex: 1;
`;

export const View = styled.p`
  color: #1E1E1E;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
`;

export const Amount = styled.p`
  color: #2A2A2A;
  text-align: right;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */
`;

export const Date = styled.p`
  color: #1E1E1E;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
`;

export const Loader = styled.div`
	width: 100%;
	height: calc(100vh - 48px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const EmptyBox = styled.div`
	width: 100%;
	height: calc(100vh - 350px);
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export const NoResultText = styled.div`
  color: #2A2A2A;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px; /* 155.556% */
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  box-sizing: border-box;

  margin: 16px auto 24px;
  width: calc(100% - 32px);

  @media screen and (max-width: 350px) {
    gap: 10px;
  }
`

export const CopyContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1;
  box-sizing: border-box;

  border-radius: 8px;
  border: 1px solid #5C5C5C;
  background: #F4F4F4;
  padding: 12px 16px;
`

export const Link = styled.p`
  overflow: hidden;
  color: #2A2A2A;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */

  word-break: break-all !important;

  flex: 1;
`

export const ShareButton = styled(AntButton)`
  height: 50px;
  font-size: 14px;
`

export const EmptyHistoryContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`

export const TNCBtn = styled(AntButton)`
  margin: 40px auto 16px;
  height: 50px;
  width: calc(100% - 32px);
`